import { Box, ButtonBase, Divider, Tooltip, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import Iconify from "../../components/iconify/Iconify";

function OrderInfoBar({
  onTableClick,
  onCustomerClick,
  onHoldClick,
  onCancelClick,
  onRemoveCustomer,
  onClearClick,
}) {
  const {
    customerDetails,
    selectedTable,
    pendingItems,
    activeOrderId,
    orderType,
  } = useSelector((state) => state.cart);
  const hasItems = pendingItems && pendingItems.length > 0;
  const name = `${customerDetails?.first_name} ${
    customerDetails?.last_name || ""
  }`;
  const isDineOrder = orderType?.type === 1;

  console.log("activeOrderId", activeOrderId);
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: "beige",
      }}
    >
      {/* Table */}
      <ButtonBase
        disabled={!isDineOrder}
        sx={{
          flexDirection: "column",
          flex: 1,
          py: 1,
          px: 1,
          borderRadius: 1,
          opacity: !isDineOrder ? 0.4 : 1,
          cursor: !isDineOrder ? "not-allowed" : "pointer",
          pointerEvents: !isDineOrder ? "none" : "auto",
        }}
        onClick={onTableClick}
      >
        <Iconify icon="hugeicons:table-round" width={22} />
        {selectedTable?.table?.table_name && (
          <Tooltip
            title={`${selectedTable?.table?.table_name} (${selectedTable?.dine_area_name})`}
          >
            <Typography
              variant="body2"
              fontWeight="500"
              sx={{
                maxWidth: "120px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {selectedTable?.table?.table_name} (
              {selectedTable?.dine_area_name})
            </Typography>
          </Tooltip>
        )}
        {!selectedTable?.table?.table_name && (
          <Tooltip title={"Select Table"}>
            <Typography
              variant="body2"
              fontWeight="500"
              noWrap
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                flexGrow: 1,
                fontSize: "12px",
              }}
            >
              Select Table
            </Typography>
          </Tooltip>
        )}
      </ButtonBase>

      <Divider orientation="vertical" flexItem />

      {/* Customer */}
      <ButtonBase
        sx={{
          flexDirection: "column",
          flex: 1,
          py: 1,
          px: 1,
          borderRadius: 1,
        }}
        onClick={onCustomerClick}
      >
        <Iconify icon="mdi:account-circle-outline" width={22} />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            maxWidth: 100,
          }}
        >
          {customerDetails?.uid && (
            <>
              <Tooltip title={name}>
                <Typography
                  variant="body2"
                  fontWeight="500"
                  noWrap
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    flexGrow: 1,
                  }}
                >
                  {name}
                </Typography>
              </Tooltip>
              {/* Cross icon styled like IconButton but not a <button> */}
              <Box
                component="span"
                onClick={(e) => {
                  e.stopPropagation();
                  onRemoveCustomer();
                }}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                  p: 0.5,
                  transition: "background-color 0.2s",
                  "&:hover": {
                    backgroundColor: "action.hover",
                  },
                  "&:active": {
                    backgroundColor: "action.selected",
                  },
                }}
              >
                <Tooltip title="Remove">
                  <Iconify icon="mdi:close" width={16} />
                </Tooltip>
              </Box>
            </>
          )}
          {!customerDetails?.uid && (
            <Tooltip title={"Add Customer"}>
              <Typography
                variant="body2"
                fontWeight="500"
                noWrap
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  flexGrow: 1,
                  fontSize: "12px",
                }}
              >
                Add Customer
              </Typography>
            </Tooltip>
          )}
        </Box>
      </ButtonBase>

      <Divider orientation="vertical" flexItem />

      {/* Hold Order */}
      {/* <ButtonBase
        sx={{
          flexDirection: "column",
          flex: 1,
          py: 1,
          px: 1,
          borderRadius: 1,
          opacity: !activeOrderId ? 0.4 : 1,
          cursor: !activeOrderId ? "not-allowed" : "pointer",
          pointerEvents: !activeOrderId ? "none" : "auto",
        }}
        onClick={onHoldClick}
        disabled={!activeOrderId}
      >
        <Iconify icon="mdi:pause-circle-outline" width={22} />
        <Typography variant="body2" fontWeight="500">
          Hold Order
        </Typography>
      </ButtonBase> */}

      <Divider orientation="vertical" flexItem />

      {/* If no active order, show disabled Cancel Order button */}
      {activeOrderId && (
        <ButtonBase
          disabled={!activeOrderId}
          sx={{
            flexDirection: "column",
            flex: 1,
            py: 1,
            px: 1,
            borderRadius: 1,
            opacity: !activeOrderId ? 0.4 : 1,
            cursor: !activeOrderId ? "not-allowed" : "pointer",
            pointerEvents: !activeOrderId ? "none" : "auto",
          }}
          onClick={onCancelClick}
        >
          <Iconify icon="mdi:close-circle-outline" width={22} color="red" />
          <Typography variant="body2" fontWeight="500" color="red">
            Cancel
          </Typography>
        </ButtonBase>
      )}

      {/* If there are items but no active order, show Clear button */}
      {!activeOrderId && (
        <ButtonBase
          disabled={!hasItems}
          sx={{
            flexDirection: "column",
            flex: 1,
            py: 1,
            px: 1,
            borderRadius: 1,
            opacity: !hasItems ? 0.4 : 1,
            cursor: !hasItems ? "not-allowed" : "pointer",
            pointerEvents: !hasItems ? "none" : "auto",
          }}
          onClick={onClearClick}
        >
          <Iconify icon="mynaui:trash" width={22} color="red" />
          <Tooltip title={"Clear all cart items"}>
            <Typography variant="body2" fontWeight="500" color="red">
              Clear
            </Typography>
          </Tooltip>
        </ButtonBase>
      )}
    </Box>
  );
}

export default OrderInfoBar;
